export default __webpack_public_path__ + "static/ProValue_4@mob-3f72c4d2b5e93ffe7bb5d6d7ea95b2df.png";